<script lang="ts">
	import WidgetButton from '$lib/widget/components/WidgetButton.svelte';
	import { type WidgetActivity } from '$lib/widget/helper/widget';
	import { widgetBooking, widgetContent } from '$lib/widget/stores';

	interface Props {
		onSave: (activity: WidgetActivity) => void;
	}

	let { onSave }: Props = $props();
</script>

{#each $widgetContent.activities as activity (activity.id)}
	<WidgetButton
		className="w-full aspect-video {$widgetBooking?.activity?.id === activity.id
			? 'z-10 scale-100'
			: ''} transition-all"
		backgroundImage={activity.image ?? ''}
		rounded="rounded"
		transparentBackground={activity.image ? true : false}
		scaleOnHover
		padding="p-4"
		selected={$widgetBooking?.activity?.id === activity.id}
		onclick={() => onSave(activity)}
	>
		{activity.name}
	</WidgetButton>
{/each}
